.time-picker-container {
  border-top: 1px solid var(--grey-300);
}

.time-picker-contents {
  padding: 0 13px 0 30px;
}

.time-picker-dropdown {
  margin: 4px 0 17px;
  width: 100%;
  height: 32px;
}

.time-picker-dropdown-toggler {
  width: 100%;
  height: 32px;
}

.checkbox-slider {
  display: block;
  padding: 16px 0;
}
